// Terakki topluluğu: duyurular ve soru, öneri, geliştirme sohbetleri WhatsApp Topluluğunda.
export const WHATSAPP_COMMUNITY_URL = "https://chat.whatsapp.com/GGF5Kh4i9fW5ELq2LRWSsS";
